var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLandmark = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10 18v-7"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.12 2.198a2 2 0 0 1 1.76.006l7.866 3.847c.476.233.31.949-.22.949H3.474c-.53 0-.695-.716-.22-.949z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M14 18v-7"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M18 18v-7"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M3 22h18"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M6 18v-7"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLandmark);
export { ForwardRef as ReactComponent };